const prodRoutes = {
  auth: {
    userAuth: "/auth/user-details",
    register: "/auth/signup",
    login: "/auth/signin",
    googleAuth: "/auth/google",
    facebookAuth: "/auth/facebook",
    linkedinAuth: "/auth/linkedin",
    resetPassword: "/auth/reset-password",
    createPassword: "/auth/create-password",
  },
  user: {
    category: {
      getAll: "/category/all",
      sub_sub: {
        fetchAll: "/sub-sub-category/all",
      },
      fetchDynamicField: "/dynamic/product/schema/fetch",
    },
    seller: {
      company: {
        fetchAll: "/seller/business/fetch/all",
        fetch: "/seller/business/fetch",
        update: "/seller/business/add-update",
        verification: {
          email: {
            initiate: "/seller/business/verification/email/sent",
            verify: "/seller/business/verification/email/verify",
          },
        },
        files: {
          businessPhotos: "/seller/business/upload/business-photos",
          govRegistration: "/seller/business/upload/government-registration",
          companyPhotos: "/seller/business/upload/company-photos",
        },
        portfolio: {
          addUpdate: "/seller/portfolio/add",
          fetchAll: "/seller/portfolio/all",
          fetch: "/seller/portfolio/fetch",
          delete: "/seller/portfolio/delete",
        },
      },
      products: {
        addUpdate: "/seller/product/add",
        fetch: "/seller/product/fetch",
        fetchAll: "/seller/product/all",
        delete: "/seller/product/delete",
      },
      service: {
        addUpdate: "/seller/service/add",
        fetch: "/seller/service/fetch",
        fetchAll: "/seller/service/all",
        delete: "/seller/service/delete",
      },
    },
  },
  buyer: {
    business: {
      addUpdate: "/buyer/business/add-update",
    },
    manage: {
      fetchRFQ: "/buyer/opportunities/my-opportunities",
      fetchRFQDetails: "/buyer/rfq/fetch/:id",
    },
  },
};

export const apiRoutes = () => prodRoutes;
